import { lazy } from 'react';

// Wrap React.lazy so a transient ChunkLoadError (stale hash after a deploy, or
// a flaky network) triggers exactly one hard reload instead of a blank page.
const RELOAD_KEY = 'bp:chunk-reload-attempted';

export function lazyRetry(factory) {
  return lazy(async () => {
    try {
      const mod = await factory();
      try { window.sessionStorage.removeItem(RELOAD_KEY); } catch { /* storage disabled */ }
      return mod;
    } catch (err) {
      let alreadyTried = false;
      try { alreadyTried = window.sessionStorage.getItem(RELOAD_KEY) === '1'; } catch { /* storage disabled */ }
      if (!alreadyTried) {
        try { window.sessionStorage.setItem(RELOAD_KEY, '1'); } catch { /* storage disabled */ }
        window.location.reload();
        return new Promise(() => {}); // halt render until the reload lands
      }
      throw err;
    }
  });
}
